/*
 * PeopleInsights.tsx
 * ===========
 * Visualize statistics related to people.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import "@material-design-icons/font/outlined.css";
import { Avatar, Collapse, Tooltip, Typography } from "antd";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
import { DataContext } from "tsproto/aware_proto/proto/Person";
import DateUtils from "ts/shared/DateUtils";
import ProtoUtils from "ts/shared/ProtoUtils";
import spacetime from "spacetime";
import { stripAddress } from "ts/shared/EventUtils";
const ContainerDiv = styled.div `
  position: absolute;
  width: 1000px;
  height: 93vh;
  top: 0;
  left: 5%;
  box-sizing: border-box;
  pointer-events: all;
  border-radius: 15px;
  background-color: rgba(0, 0, 0, 0.5);
  /* border: 1px solid red; */
`;
const ScrollDiv = styled.div `
  position: relative;
  width: 100%;
  height: 82vh;
  overflow: auto;
  overflow-y: scroll;
  padding-right: 10px;
  pointer-events: all;
  text-align: left;
  &::-webkit-scrollbar {
    height: 5px;
    width: 5px;
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(128, 128, 128, 0.5);
    border-radius: 5px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  /* border: 1px solid blue; */
`;
const ContentDiv = styled.div `
  padding: 30px;
  /* border: 1px solid red; */
  width: 100%;
  height: 100%;
`;
const ContentHeading = styled.div `
  margin-bottom: 25px;
  font-size: 36px;
  font-weight: bold;
`;
const DescriptionDiv = styled.div `
  font-size: 18px;
  margin-bottom: 25px;
`;
const StyledCollapse = styled(Collapse) `
  .ant-collapse-header:hover {
    background-color: rgba(128, 128, 128, 0.5);
  }
  .ant-collapse-item-active > .ant-collapse-header {
    background-color: rgba(128, 128, 128, 0.5);
  }
  .ant-collapse-content {
    background-color: transparent;
  }
`;
const PersonDiv = styled.div `
`;
const PersonTopRowDiv = styled.div `
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-left: 15px;
  padding-right: 15px;
`;
const PersonNameDiv = styled.div `
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  font-size: 24px;
  margin-left: 15px;
  /* border: 1px solid yellow; */
`;
const NTimesDiv = styled.div `
  height: 100%;
  width: 25%;
  font-size: 20px;
  color: white;
  text-align: center;
  /* border: 1px solid magenta; */
`;
const PeriodDiv = styled.div `
  height: 100%;
  width: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 20px;
  color: cyan; // rgb(247, 91, 85);
  /* border: 1px solid cyan; */
`;
const ProgressLabelDiv = styled.div `
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  width: 850px;
  margin-left: 10px;
  margin-top: 15px;
`;
const ProgressBarDiv = styled.div `
  display: flex;
  align-items: flex-start;
  height: 30px;
  width: 850px;
  margin-left: 10px;
  border: 1px solid rgb(192, 192, 192);
  color: white;
`;
const MeetingSectionDiv = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 10px;
  /* border: 1px solid red; */
`;
const ReachOutDiv = styled.div `
  display: flex;
  align-items: flex-start;
  font-size: 18px;
  margin-bottom: 10px;
  gap: 8px;
`;
const MeetingRowDiv = styled.div `
  display: flex;
  align-items: flex-start;
  margin-bottom: 5px;
`;
const MeetingLabelDiv = styled.div `
  width: 75px;
  font-size: 20px;
  font-variant: all-small-caps;
  text-align: center;
`;
const MeetingDiv = styled.div `
  width: 15px;
  height: 25px;
  border: 1px solid white;
  background: rgba(255, 255, 255, 0.5);
  &.isFuture {
    border: 1px solid darkgray;
    background: rgba(64, 64, 64, 0.5);
  }
  &.hasMeetings {
    background: rgba(0, 255, 255, 0.4); //rgb(247, 91, 85);
  }
  &.hasMeetings:hover {
    border: 2px solid rgb(247, 91, 85);
  }
`;
let meetingsByPerson = {};
class PeopleInsightsProps {
    userMap;
    activityInsights;
}
class PeopleInsightsState {
    personSelected;
}
let PeopleInsights = class PeopleInsights extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            personSelected: "",
        };
    }
    getPeriodDescription(person) {
        const personInsights = this.props.activityInsights?.personInsights;
        const stats = personInsights.personStatistics[person.personUid];
        if (stats.allEvents.length === 1) {
            return React.createElement("div", { style: { color: "white" } }, "once");
        }
        const seconds = stats.activityIntervalDistribution.medianIntervalSeconds;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: { color: "white", marginRight: "5px" } }, "every"),
            React.createElement("div", null, `${DateUtils.getPeriodString(seconds)}`)));
    }
    getNTimesString(person) {
        const personInsights = this.props.activityInsights?.personInsights;
        const stats = personInsights.personStatistics[person.personUid];
        return `${stats.allEvents.length}x`;
    }
    getMeetingsByPerson() {
        const personInsights = this.props.activityInsights?.personInsights;
        const tz = DateUtils.defaultTimezone;
        const today = spacetime.now();
        if (personInsights && Object.keys(meetingsByPerson).length === 0) {
            for (const person of personInsights.peopleMet) {
                const stats = personInsights.personStatistics[person.personUid];
                const years = [];
                const allMeetings = {};
                for (const event of stats.allEvents) {
                    const st = ProtoUtils.toSpacetime(event.startDate, tz);
                    const year = st.year();
                    if (!years.includes(year)) {
                        years.push(year);
                    }
                }
                const stLast = ProtoUtils.toSpacetime(stats.allEvents.at(-1).startDate, tz);
                let stNext, nextNWeeks, nextColor, nextDescription1, nextDescription2;
                if (stats.allEvents.length > 1) {
                    const periodSecs = stats.activityIntervalDistribution.medianIntervalSeconds;
                    stNext = stLast.add(periodSecs, "seconds");
                    nextNWeeks = nWeeks(stNext);
                    if (!years.includes(stNext.year())) {
                        years.push(stNext.year());
                    }
                    nextColor = "";
                    if (today.year() === stNext.year() && nWeeks(today) === nextNWeeks) {
                        nextColor = "#7fe817";
                        nextDescription1 = "this week";
                        nextDescription2 = "";
                    }
                    else if (stNext.isAfter(today.startOf("week"))) {
                        nextColor = "#7fe817";
                        nextDescription1 = DateUtils.getPeriodString(today.diff(stNext, "seconds"));
                        nextDescription2 = "from now";
                    }
                    else {
                        const diffSecs = stNext.diff(today, "seconds");
                        const ratio = diffSecs / (2 * periodSecs);
                        nextColor = interpolateColor("#ccff00", "#ff0000", ratio);
                        nextDescription1 = DateUtils.getPeriodString(diffSecs);
                        nextDescription2 = "ago";
                    }
                }
                years.forEach(year => allMeetings[year] = {});
                years.sort((a, b) => b - a);
                let nInPerson = 0;
                let nPersonal = 0, nWork = 0;
                for (const event of stats.allEvents) {
                    const st = ProtoUtils.toSpacetime(event.startDate, tz);
                    const year = st.year();
                    const meetingsByWeek = allMeetings[year];
                    const diffWeeks = nWeeks(st);
                    if (!meetingsByWeek[diffWeeks]) {
                        meetingsByWeek[diffWeeks] = [];
                    }
                    meetingsByWeek[diffWeeks].push(event);
                    if (isLocationInPerson(event.calendarEvent?.location)) {
                        nInPerson++;
                        // console.log(event.calendarEvent.location);
                    }
                    if (event.dataContexts.some(v => v === DataContext.Personal)) {
                        nPersonal++;
                    }
                    if (event.dataContexts.some(v => v === DataContext.Work)) {
                        nWork++;
                    }
                }
                // console.log(`${person.names[0].firstName} has  ${nPersonal}, ${nWork} events`);
                const meeting = {
                    person: person,
                    years: years,
                    meetings: allMeetings,
                    stNextMeeting: stNext,
                    stNextWeeks: stNext && nextNWeeks,
                    nextColor: nextColor,
                    nextDescription: stNext &&
                        React.createElement(ReachOutDiv, null,
                            React.createElement(React.Fragment, null, "Reach out next on"),
                            React.createElement("div", { style: { color: nextColor } }, stNext.format("{month-short} {date}, {year}")),
                            React.createElement(React.Fragment, null, `(`),
                            React.createElement("div", { style: { color: nextColor, marginLeft: "-8px" } }, nextDescription1),
                            nextDescription2 ?
                                React.createElement(React.Fragment, null, `${nextDescription2})`) :
                                React.createElement("div", { style: { marginLeft: "-8px" } }, ")")),
                    fracInPerson: nInPerson / stats.allEvents.length,
                    fracPersonal: (nPersonal + nWork > 0) ? nPersonal / (nPersonal + nWork) : 0
                };
                meetingsByPerson[person.personUid] = meeting;
            }
        }
        return meetingsByPerson;
    }
    getMeetingsForPerson(person) {
        const meetings = this.getMeetingsByPerson()[person.personUid];
        if (!meetings)
            return React.createElement(React.Fragment, null);
        const today = spacetime.now();
        const todayWeeks = nWeeks(today);
        return (React.createElement(MeetingSectionDiv, null,
            React.createElement(ProgressLabelDiv, null,
                React.createElement("div", { style: { color: "rgb(64, 192, 255)" } }, `${(100 * meetings.fracPersonal).toFixed(0)}% personal`),
                React.createElement("div", { style: { color: "rgb(128, 128, 255)" } }, `${(100 - 100 * meetings.fracPersonal).toFixed(0)}% work`)),
            React.createElement(ProgressBarDiv, null,
                React.createElement("div", { style: {
                        height: "100%",
                        width: `${100 * meetings.fracPersonal}%`,
                        background: "rgba(64, 192, 255, 0.8)"
                    } }),
                React.createElement("div", { style: {
                        height: "100%",
                        width: `${100 - 100 * meetings.fracPersonal}%`,
                        background: "rgba(128, 128, 255, 0.8)"
                    } })),
            React.createElement(ProgressLabelDiv, null,
                React.createElement("div", { style: { color: "rgb(64, 192, 255)" } }, `${(100 * meetings.fracInPerson).toFixed(0)}% in person`),
                React.createElement("div", { style: { color: "rgb(128, 128, 255)" } }, `${(100 - 100 * meetings.fracInPerson).toFixed(0)}% virtual`)),
            React.createElement(ProgressBarDiv, null,
                React.createElement("div", { style: {
                        height: "100%",
                        width: `${100 * meetings.fracInPerson}%`,
                        background: "rgba(64, 192, 255, 0.8)"
                    } }),
                React.createElement("div", { style: {
                        height: "100%",
                        width: `${100 - 100 * meetings.fracInPerson}%`,
                        background: "rgba(128, 128, 255, 0.8)"
                    } })),
            React.createElement("div", { style: { marginTop: "30px" } }, meetings.nextDescription && meetings.nextDescription),
            meetings.years.map(year => React.createElement(MeetingRowDiv, { key: year },
                React.createElement(MeetingLabelDiv, null, year),
                Array.from({ length: 52 }, (v, i) => i).map(week => {
                    const meetingsByWeek = meetings.meetings[year];
                    const hasMeetings = (meetingsByWeek[week])?.length > 0;
                    const isFuture = year > today.year() || today.year() === year && week > todayWeeks;
                    let className = "";
                    if (hasMeetings)
                        className = "hasMeetings";
                    if (isFuture)
                        className = "isFuture";
                    let style = {};
                    if (meetings.stNextMeeting?.year() === year && meetings.stNextWeeks === week) {
                        style = { background: meetings.nextColor };
                    }
                    if (hasMeetings) {
                        return (React.createElement(Tooltip, { key: week, placement: "top", styles: { root: { maxWidth: "750px" } }, onOpenChange: (open) => {
                                for (const event of meetingsByWeek[week]) {
                                    if (event.placeUid) {
                                        this.props.userMap.setHighlighted(event.placeUid, open);
                                    }
                                }
                            }, title: React.createElement(React.Fragment, null, meetingsByWeek[week]?.map(event => {
                                const st = ProtoUtils.toSpacetime(event.startDate, DateUtils.defaultTimezone);
                                const dateStr = `${st.month() + 1}/${st.date()}`;
                                return React.createElement(Typography, { key: event.eventUid },
                                    dateStr,
                                    " ",
                                    event.eventName);
                            })) },
                            React.createElement(MeetingDiv, { className: className, style: style })));
                    }
                    else {
                        return React.createElement(MeetingDiv, { key: week, className: className, style: style });
                    }
                })))));
    }
    showPersonPlacesOnMap(personUid) {
        const personInsights = this.props.activityInsights?.personInsights;
        const stats = personInsights.personStatistics[personUid];
        const userMap = this.props.userMap;
        const places = {};
        for (const event of stats.allEvents) {
            if (!event.placeUid)
                continue;
            if (event.placeUid in places)
                continue;
            const place = personInsights.referencedPlaces[event.placeUid];
            if (place) {
                places[event.placeUid] = place;
            }
        }
        userMap.clearPlaceLayerSourceData();
        userMap.updatePlaceLayerSourceData(Object.values(places));
        userMap.showMarkerSet(Object.values(places), false);
    }
    render() {
        const personInsights = this.props.activityInsights?.personInsights;
        const people = personInsights?.peopleMet || [];
        const items = people.map(person => {
            return {
                key: `${person.personUid}`,
                showArrow: false,
                label: React.createElement(PersonTopRowDiv, null,
                    React.createElement(Avatar.Group, { style: { marginRight: "5px" } }, person.photoUrls.map((photoUrl) => React.createElement(Avatar, { size: 36, src: `${photoUrl}`, key: photoUrl, style: { border: "1px solid white" } }))),
                    React.createElement(PersonNameDiv, null, `${person.names[0].firstName} ${person.names[0].lastName}`),
                    React.createElement(NTimesDiv, null, `${this.getNTimesString(person)}`),
                    React.createElement(PeriodDiv, null, this.getPeriodDescription(person))),
                children: this.getMeetingsForPerson(person)
            };
        });
        return (React.createElement(ContainerDiv, null,
            React.createElement(ContentDiv, null,
                React.createElement(ContentHeading, null, "Your Contacts"),
                React.createElement(DescriptionDiv, null, "The people you've met with the most frequently."),
                React.createElement(ScrollDiv, null,
                    React.createElement(StyledCollapse, { accordion: true, items: items, onChange: (keys) => {
                            if (keys.length === 0) {
                                this.setState({ personSelected: "" });
                            }
                            else {
                                const personUid = keys[0];
                                this.setState({ personSelected: personUid });
                                this.showPersonPlacesOnMap(personUid);
                            }
                        } })))));
    }
};
PeopleInsights = __decorate([
    observer
], PeopleInsights);
export default PeopleInsights;
function nWeeks(st) {
    if (!st)
        return undefined;
    return Math.floor(st.startOf("year").diff(st, "weeks"));
}
function interpolateColor(color1Hex, color2Hex, factor) {
    factor = Math.min(1, Math.max(0, factor));
    const hexToRgb = (hex) => {
        const r = parseInt(hex.substring(1, 3), 16);
        const g = parseInt(hex.substring(3, 5), 16);
        const b = parseInt(hex.substring(5, 7), 16);
        return [r, g, b];
    };
    const rgbToHex = (r, g, b) => {
        return "#" +
            ((1 << 24) + (r << 16) + (g << 8) + b)
                .toString(16)
                .slice(1);
    };
    const color1Rgb = hexToRgb(color1Hex);
    const color2Rgb = hexToRgb(color2Hex);
    const interpolatedRgb = [];
    for (let i = 0; i < 3; i++) {
        interpolatedRgb[i] = Math.round(color1Rgb[i] + factor * (color2Rgb[i] - color1Rgb[i]));
    }
    return rgbToHex(interpolatedRgb[0], interpolatedRgb[1], interpolatedRgb[2]);
}
function isLocationInPerson(location) {
    if (!location)
        return false;
    if (location.includes(".zoom.us"))
        return false;
    if (location.includes(".webex.com"))
        return false;
    if (location.includes("WebEx"))
        return false;
    if (location.includes("Microsoft Teams"))
        return false;
    if (location.includes("Google Meet"))
        return false;
    const phoneFinderRegex = /(?:\+1)?\s?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}/g;
    if (location.match(phoneFinderRegex)?.length > 0)
        return false;
    return true;
}
function stripAddressFromPlaceNames(activityInsights) {
    const places = Object.values(activityInsights.personInsights.referencedPlaces);
    for (const place of places) {
        const name0 = place.displayNames[0].name;
        const strippedName = stripAddress(name0);
        if (!strippedName)
            continue;
        if (name0 === strippedName)
            continue;
        if (process.env.NODE_ENV === "development") {
            console.log(`Replacing ${name0} with ${strippedName}`);
        }
        place.displayNames[0].name = strippedName;
    }
}
async function filterPhotoUrls(personInsights) {
    const tStart = new Date();
    const promises = [];
    const defaultPhotoUrls = [];
    for (const person of personInsights.peopleMet) {
        const photoUrls = person.photoUrls;
        if (photoUrls.length <= 1) {
            continue;
        }
        for (let i = 0; i < photoUrls.length; ++i) {
            const photoUrl = photoUrls[i];
            const p = fetch(photoUrl);
            promises.push(p);
            p.catch(error => {
                // const personName = `${person.names[0].firstName} ${person.names[0].lastName}`;
                // console.error(`${i} ${personName} ${photoUrl}`);
                defaultPhotoUrls.push(photoUrl);
            });
        }
    }
    await Promise.allSettled(promises);
    for (const person of personInsights.peopleMet) {
        const defaults = person.photoUrls.filter(v => defaultPhotoUrls.includes(v));
        const initials = person.photoUrls.filter(v => v.includes(".googleusercontent.com/cm/"));
        const custom = person.photoUrls.filter(v => !defaults.includes(v) && !initials.includes(v));
        if (custom.length === 0) {
            if (initials.length > 0) {
                person.photoUrls = [initials[0]];
            }
            else {
                person.photoUrls = [person.photoUrls[0]];
            }
        }
        else {
            person.photoUrls = custom;
        }
    }
    const tEnd = new Date();
    if (process.env.NODE_ENV === "development") {
        console.log(`${defaultPhotoUrls.length} default photos found.`);
        console.log(`Filtered photoUrls in ${tEnd.getTime() - tStart.getTime()} ms`);
    }
}
export { filterPhotoUrls, stripAddressFromPlaceNames };
